import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type StaffMembersFetchFailedAction = {
	type: 'STAFF_MEMBERS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): StaffMembersFetchFailedAction => ({
	type: 'STAFF_MEMBERS_FETCH_FAILED',
	payload,
});
